async function resolveLink (link, linkFallback) {
  if (!link) return null
  if (!linkFallback) return link

  try {
    await fetch(link, { method: 'HEAD', signal: AbortSignal.timeout(2000) })
    return link
  } catch {
    return linkFallback
  }
}

export { resolveLink }
